import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./assets/css/main.css";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { indigo, red } from "@material-ui/core/colors";
import { Provider } from "react-redux";
import { CookiesProvider } from 'react-cookie'
import createAppStore from "./store";
// import { AWS_PINPOINT_APP_ID, IDENTITY_POOL_ID } from './utils/CommonConstant';
// import Analytics from '@aws-amplify/analytics';
// import Auth from '@aws-amplify/auth';
const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      light: indigo,
      main: "#004E96",
      dark: "#002767"
    },
    secondary: {
      light: "#FFA726",
      main: "#F68B1E",
      dark: "#EF6C00",
    },
    error: {
      light: red[300],
      main: red[500],
      dark: red[700]
    },
    background: {
      paper: "#FFFFFF",
      default: "#F5F5F6"
    },
    typography: {
      useNextVariants: true
    },
    stepper: {
      iconColor: '#F68B1E'
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        '&$active': {
          color: '#F68B1E',
        },
        '&$completed': {
          color: '#F68B1E',
        }
      }
    }
  }
})


// const amplifyConfig = {
//   Auth: {
//     identityPoolId: IDENTITY_POOL_ID,
//     region: 'us-east-1'
//   }
// }
// //Initialize Amplify
// Auth.configure(amplifyConfig);

// const analyticsConfig = {
//   AWSPinpoint: {
//     // Amazon Pinpoint App Client ID
//     appId: AWS_PINPOINT_APP_ID,
//     // Amazon service region
//     region: 'us-east-1',
//     mandatorySignIn: false,
//   }
// }
// Analytics.configure(analyticsConfig)

const initialState = {};
const store = createAppStore(initialState);

ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <App />
      </MuiThemeProvider>
    </Provider>
  </CookiesProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
